export default {
  'sidebar.devolucionproveedor': 'Supplier return',
  'devolucion.alerta.agregarDetalles': 'It is not possible to delete the last detail of the document, please check.',
  'devolucion.alerta.agregarDetallesAnulado': 'It is not possible to modify the document information at the current stage, please check.',
  'devolucion.alerta.agregarDetallesCerrado': 'It is not possible to modify information of a closed document, please check.',
};
